var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showShare)?_c('div',{staticClass:"share",on:{"click":_vm.aa}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc"},[_vm._v(" 点击右上角分享给好友，邀请好友入团 "),_c('img',{attrs:{"src":require("@/assets/share.png")}})])
}]

export { render, staticRenderFns }